import { ArtistContextIdFilterState, DEFAULT_ARTIST_CONTEXT_ID_VALUE } from './artistContextId.types';

export const getDefaultArtistContextIdFilter = (): ArtistContextIdFilterState => ({
  selectedArtistContextId: DEFAULT_ARTIST_CONTEXT_ID_VALUE,
});
export const defaultArtistsFilter = getDefaultArtistContextIdFilter();
